var Component = require("!../../../../../../../../../../../L180/prototypes/uni-uswebapp/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../../../../../L180/prototypes/uni-uswebapp/node_modules/vue-loader/lib/selector?type=script&index=0!./Settings.vue"),
  /* template */
  require("!!../../../../../../../../../../../L180/prototypes/uni-uswebapp/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-18f2920e\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../../../../../../../../../L180/prototypes/uni-uswebapp/node_modules/vue-loader/lib/selector?type=template&index=0!./Settings.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Settings.vue
// module id = 404
// module chunks = 26